import { createContext } from 'react';

interface IAuthContextProps {
  user: any;
  setUser: (user: any) => void;
}

export default createContext({} as IAuthContextProps);